export const categories = [
  {
    slug: 'access-tutorial',
    name: '访问教程',
    description: '详细的91网页版入口访问步骤指南',
    icon: 'ri-guide-line',
    count: 12,
  },
  {
    slug: 'faq-solutions',
    name: '常见问题',
    description: '91网页版无法打开等问题的解决方法',
    icon: 'ri-question-answer-line',
    count: 18,
  },
  {
    slug: 'latest-news',
    name: '最新动态',
    description: '91平台网页版的最新更新与公告',
    icon: 'ri-flashlight-line',
    count: 8,
  },
  {
    slug: 'usage-tips',
    name: '使用技巧',
    description: '提升91网页版使用体验的实用技巧',
    icon: 'ri-lightbulb-line',
    count: 15,
  },
  {
    slug: 'account-security',
    name: '账号安全',
    description: '91网页版账号保护与安全设置指南',
    icon: 'ri-shield-check-line',
    count: 10,
  },
  {
    slug: 'platform-guide',
    name: '平台指南',
    description: '91平台网页版各功能模块使用说明',
    icon: 'ri-book-open-line',
    count: 14,
  },
];